import React, { Fragment } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import SpacingProps from './styleProps/SpacingProps.js';
import SizingProps from './styleProps/SizingProps.js';
import TextProps from './styleProps/TextProps.js';
import BorderProps from './styleProps/BorderProps.js';
import FlexProps from './styleProps/FlexProps.js';

const StyleEditor = (props) => {
    const options = [
        {
            name: 'Spacing',
            type: 'spacing'
        },
        {
            name: 'Sizing',
            type: 'size'
        },
        {
            name: 'Text',
            type: 'text'
        },
        ,
        {
            name: 'Border',
            type: 'border'
        }
    ];
    const factory = (opts) => {
        let component = null;
        switch (opts.type) {
            case "layout":
                component = React.createElement(FlexProps, null);
                break;
            case "spacing":
                component = React.createElement(SpacingProps, null);
                break;
            case "size":
                component = React.createElement(SizingProps, null);
                break;
            case "text":
                component = React.createElement(TextProps, null);
                break;
            case "border":
                component = React.createElement(BorderProps, null);
                break;
        }
        return React.createElement(AccordionTab, { header: opts.name }, component);
    };
    return React.createElement(Fragment, null,
        React.createElement(Accordion, null, options.map((opts) => factory(opts))));
};

export { StyleEditor as default };
//# sourceMappingURL=StyleEditor.js.map
